// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__sBNxq","label":"style_label__V230n","actions":"style_actions__tjDVa","actions_btn":"style_actions_btn__7e6VT"};